<template>
  <div>
    <div>
      <div class="row">
        <div class="col">
          <div class="form-group">
            <label for="length" class="font-weight-bold">Länge</label>
            <input v-model="getCalculator.length"
              @input="$store.dispatch('saveCalculator', formData)"
              type="range" 
              min="1"
              max="20"
              class="w-100">
            <div class="input-group">
              <input v-model="getCalculator.length"
                @input="$store.dispatch('saveCalculator', formData)"
                id="length"
                class="form-control"
                type="number" 
                min="0">
              <span class="input-group-addon" id="basic-addon2">Meter</span>
            </div>
          </div>
        </div>
        <div class="col">
          <div class="form-group">
            <label for="width" class="font-weight-bold">Breite</label>
            <input v-model="getCalculator.width"
              @input="$store.dispatch('saveCalculator', formData)"
              type="range" 
              min="1" 
              max="20"
              class="w-100">
            <div class="input-group">
              <input v-model="getCalculator.width"
                @input="$store.dispatch('saveCalculator', formData)"
                id="length"
                class="form-control"
                type="number" 
                min="0">
              <span class="input-group-addon" id="basic-addon2">Meter</span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-if="squareMeter > 0">
      <div class="alert alert-success">
        <div class="mb-1">Bei einer Fläche von <strong>{{ squareMeter.toString().replace('.', ',') }} m²</strong> benötigen Sie <strong>ca. <span>{{ consumption }}</span> kg</strong></div>
        <div class="mb-1">Verbrauch: <span v-if="getCalculator.fleece">2,0 kg/m²</span><span v-else>1,4 kg/m²</span></div>
        <div>Anzahl Anstriche: 2</div>
      </div>
    </div>
    <div class="m-0">
      <label class="custom-control custom-checkbox mb-0">
        <input type="checkbox" 
          v-model="formData.fleece"
          @change="$store.dispatch('saveCalculator', formData)" 
          class="custom-control-input">
        <span class="custom-control-indicator"></span>
        <span class="custom-control-description"><small>Vliesverstärkung (höherer Verbrauch)</small></span>
      </label>
    </div>
    <div class="mb-3">
      <label class="custom-control custom-checkbox m-0">
        <input type="checkbox" 
          v-model="user.isB2B"
          @change="$store.dispatch('b2bUser', user.isB2B)"
          class="custom-control-input">
        <span class="custom-control-indicator"></span>
        <span class="custom-control-description"><small>Ich bin professioneller Handwerker</small></span>
      </label>
    </div>
    <div>
      <a 
      :href="CTAURL+CTAParameter"
      class="btn btn-primary btn-block btn-lg"
      target="_blank" 
      >{{ CTAText }}</a>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  data () {
    return {
      flachdachSet: false
    }
  },
  computed: {
    ...mapGetters([
      'getCalculator',
      'isB2B'
    ]),
    squareMeter () {
      let squareMeter = 0

      if (this.getCalculator.length > 0 && this.getCalculator.width > 0) {
        squareMeter = Math.round(this.getCalculator.length * this.getCalculator.width * 100) / 100
      }

      return squareMeter
    },
    consumption () {
      const consumption = (Math.round(this.squareMeter * this.thickness * 100) / 100) * 2

      return consumption.toString().replace('.', ',')
    },
    thickness () {
      let thickness = 1.4

      if (this.getCalculator.fleece) {
        thickness = 2
      }

      return thickness
    },
    formData () {
      return {
        width: this.getCalculator.width,
        length: this.getCalculator.length,
        squareMeter: this.squareMeter,
        fleece: this.getCalculator.fleece
      }
    },
    user () {
      return this.$store.state.user
    },
    CTAText () {
      if (this.isB2B) {
        return 'Bei Alfa Direkt bestellen'
      }
      return 'Bei Heimwerker Direkt bestellen'
    },
    CTAURL () {
      if (this.isB2B) {
        if (this.flachdachSet === true) {
          return 'https://www.alfa-direkt.de/804-alfa-flachdachabdichtung-set-mit-vlies'
        }
        return 'https://www.alfa-direkt.de/805-alfa-easy-flachdachabdichtung-1k'
      }
      if (this.flachdachSet === true) {
        return 'https://www.heimwerker-direkt.de/flachdachabdichtungs-set-mit-vlies'
      }
      return 'https://www.heimwerker-direkt.de/easy-flachdachabdichtung-1k-198'
    },
    CTAParameter () {
      const keyword = this.$store.state.keyword
      return `?pk_campaign=dynlp&pk_kwd=${keyword}&pk_source=dynlp&pk_medium=cta&utm_source=dynlp&utm_medium=cta&utm_campaign=dynlp&utm_term=${keyword}`
    }
  },
  mounted () {
    if (typeof this.$route.query.flachdachSet !== 'undefined') {
      this.flachdachSet = true
    }
  }
}
</script>

<style lang="scss" scoped>
  @import "~bootstrap/scss/_functions";
  @import "src/assets/scss/_variables";
</style>



// WEBPACK FOOTER //
// src/components/Calculator.vue